// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.created-customer-content-xQBXi {
  display: flex;
  flex-grow: 1;
  flex-wrap: nowrap;
  overflow: hidden;
}

.created-customer-customerCard_container-TL6AM {
  flex-shrink: 0;
}

.created-customer-rightContent-7MWVC {
  flex-grow: 1;
  display: flex;
  flex-flow: column nowrap;
  padding: 0px 12px 0px 48px;
  overflow-x: hidden;
  overflow-y: auto;
}

.created-customer-loginInfo-Fv9p2 {
  padding: 20px 16px;
}

.created-customer-loginInfoContent-xZZGV {
  display: flex;
  margin-top: 32px;
}

.created-customer-fillTextItem_container-jdrXt {
  width: 260px;
  background-color: var(--background-color);
  border-radius: var(--large-border-radius);
  border-bottom: 0px;
  padding: 16px;
  margin-right: 44px;
}

.created-customer-fillTextItem_content-xLCVa {
  margin-top: 12px;
}

.created-customer-fillTextItem_text-U1Of_ {
  font-weight: 500;
}

.created-customer-activationLink_container-pjWAJ {
  width: 100%;
  margin-top: 32px;
}

.created-customer-activationLink_content-uu0vF {
  margin-top: 12px;
}

.created-customer-activationLink_text-A4FhN {
  color: var(--link-color);
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
}

.created-customer-appsContainer-GlhK6 {
  display: grid;
  grid-template-columns: repeat(auto-fit, 260px);
  column-gap: 52px;
}

.created-customer-appCard-vA1xb {
  width: 260px;
  height: 290px;
  display: flex;
  flex-shrink: 0;
  margin-top: 32px;
  flex-direction: column;
  align-items: center;
}

.created-customer-appCard-vA1xb:nth-child(2) {
  justify-self: center;
}

.created-customer-appCard-vA1xb:last-child {
  justify-self: flex-end;
}

.created-customer-appCardImage-idyDc {
  height: 40px;
  margin-top: 24px;
}

.created-customer-appCardTitle-ZYFqy {
  margin-top: 16px;
  font-weight: 500;
}

.created-customer-appCardVersion-t9eLX {
  margin-top: 12px;
}

.created-customer-appCardUrl-v09C3 {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--link-color);
}

.created-customer-externalIcon-Ao9cL {
  --size: 18px;
  margin-left: 4px;
  margin-top: 1px;
}

.created-customer-appCardOptions-YW8wk {
  width: 100%;
  margin-top: 24px;
}

.created-customer-appCardOption_container-fQTbV {
  width: calc(100% - 40px);
  background-color: var(--background-color);
  border-radius: 4px;
  padding: 12px;
  margin: 12px auto;
  color: #4B4B4B;
}

.created-customer-appCardOption_container-fQTbV * {
  cursor: default;
}

.created-customer-appCardOption_icon-CX6Al {
  --size: 20px;
}

.created-customer-appCardOption_text-xP8ZH {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/created-customer/created-customer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".content {\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n.customerCard_container {\n  flex-shrink: 0;\n}\n\n.rightContent {\n  flex-grow: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  padding: 0px 12px 0px 48px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.loginInfo {\n  padding: 20px 16px;\n}\n\n.loginInfoContent {\n  display: flex;\n  margin-top: 32px;\n}\n\n.fillTextItem_container {\n  width: 260px;\n  background-color: var(--background-color);\n  border-radius: var(--large-border-radius);\n  border-bottom: 0px;\n  padding: 16px;\n  margin-right: 44px;\n}\n\n.fillTextItem_content {\n  margin-top: 12px;\n}\n\n.fillTextItem_text {\n  font-weight: 500;\n}\n\n.activationLink_container {\n  composes: fillTextItem_container;\n  width: 100%;\n  margin-top: 32px;\n}\n\n.activationLink_content {\n  margin-top: 12px;\n}\n\n.activationLink_text {\n  color: var(--link-color);\n  font-size: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.appsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 260px);\n  column-gap: 52px;\n}\n\n.appCard {\n  width: 260px;\n  height: 290px;\n  display: flex;\n  flex-shrink: 0;\n  margin-top: 32px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.appCard:nth-child(2) {\n  justify-self: center;\n}\n\n.appCard:last-child {\n  justify-self: flex-end;\n}\n\n.appCardImage {\n  height: 40px;\n  margin-top: 24px;\n}\n\n.appCardTitle {\n  margin-top: 16px;\n  font-weight: 500;\n}\n\n.appCardVersion {\n  margin-top: 12px;\n}\n\n.appCardUrl {\n  composes: appCardVersion;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: var(--link-color);\n}\n\n.externalIcon {\n  --size: 18px;\n  margin-left: 4px;\n  margin-top: 1px;\n}\n\n.appCardOptions {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.appCardOption_container {\n  width: calc(100% - 40px);\n  background-color: var(--background-color);\n  border-radius: 4px;\n  padding: 12px;\n  margin: 12px auto;\n  color: #4B4B4B;\n}\n\n.appCardOption_container * {\n  cursor: default;\n}\n\n.appCardOption_icon {\n  --size: 20px;\n}\n\n.appCardOption_text {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `created-customer-content-xQBXi`,
	"customerCard_container": `created-customer-customerCard_container-TL6AM`,
	"rightContent": `created-customer-rightContent-7MWVC`,
	"loginInfo": `created-customer-loginInfo-Fv9p2`,
	"loginInfoContent": `created-customer-loginInfoContent-xZZGV`,
	"fillTextItem_container": `created-customer-fillTextItem_container-jdrXt`,
	"fillTextItem_content": `created-customer-fillTextItem_content-xLCVa`,
	"fillTextItem_text": `created-customer-fillTextItem_text-U1Of_`,
	"activationLink_container": `created-customer-activationLink_container-pjWAJ created-customer-fillTextItem_container-jdrXt`,
	"activationLink_content": `created-customer-activationLink_content-uu0vF`,
	"activationLink_text": `created-customer-activationLink_text-A4FhN`,
	"appsContainer": `created-customer-appsContainer-GlhK6`,
	"appCard": `created-customer-appCard-vA1xb`,
	"appCardImage": `created-customer-appCardImage-idyDc`,
	"appCardTitle": `created-customer-appCardTitle-ZYFqy`,
	"appCardVersion": `created-customer-appCardVersion-t9eLX`,
	"appCardUrl": `created-customer-appCardUrl-v09C3 created-customer-appCardVersion-t9eLX`,
	"externalIcon": `created-customer-externalIcon-Ao9cL`,
	"appCardOptions": `created-customer-appCardOptions-YW8wk`,
	"appCardOption_container": `created-customer-appCardOption_container-fQTbV`,
	"appCardOption_icon": `created-customer-appCardOption_icon-CX6Al`,
	"appCardOption_text": `created-customer-appCardOption_text-xP8ZH`
};
export default ___CSS_LOADER_EXPORT___;
